// Hardcoded for now; works on all envs so we can test. Limit to prod later.
export const GTAG_ID = "G-CXVE9E8544"

export function GoogleAnalytics({ gaId = GTAG_ID }: { gaId?: string }) {
  return (
    <>
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${gaId}');`,
        }}
      />
    </>
  )
}
